/**
 * Region configuration utility
 *
 * Builds path-based API URLs for multi-region routing.
 * All traffic flows through a single domain with region encoded in the path:
 *   /api/{region}/...
 *
 * Available regions are fetched from the API (GET /regions), not from env vars.
 */

import { RUNTIME_CONFIG } from './runtime-config';

/**
 * Default region to use when no tenant is selected (bootstraps the first API call)
 */
export const DEFAULT_REGION = RUNTIME_CONFIG.defaultRegion;

/**
 * Get the API base URL for a specific region
 *
 * @param region - Region code (e.g., 'eu', 'us')
 * @returns Path-based API URL (e.g., '/api/eu')
 */
export function getApiUrlForRegion(region: string): string {
    return `/api/${region.toLowerCase()}`;
}
